import { render, staticRenderFns } from "./CategoryCreateForm.vue?vue&type=template&id=fd5eb5e4&"
import script from "./CategoryCreateForm.vue?vue&type=script&lang=js&"
export * from "./CategoryCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports